import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import { MakeBackup } from "../../api/api";
import SuccessToast from "../toasts/SuccessToast";
import ErrorToast from "../toasts/ErrorToast";

const BackupModal = () => {
  const { setBackupModal, setIsLoading } = useContext(Context);
  const [backupName, setBackupName] = useState("");
  const [limited, setLimited] = useState(false);
  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setBackupModal(modalName);
  }, []);

  const handleSetBackupName = (e) => {
    if (e.target.value.length <= 40) {
      setBackupName(e.target.value);
    }
  };

  const handleSubmit = () => {
    setIsLoading(true);
    MakeBackup({
      backup_name: backupName,
      limited: limited,
    }).then(({ data }) => {
      if (!data.error) {
        SuccessToast(data.message);
        closeButton.current.click();
        setIsLoading(false);
      } else {
        ErrorToast(data.message);
      }
    });
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="backupModal"
      tabIndex="-1"
      aria-labelledby="backupModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="backupModalLable">
              پشتیبان گیری
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div>
              <label htmlFor="defaultFormControlInput" className="form-label">
                نام
              </label>
              <input
                type="text"
                className="form-control"
                id="backupName"
                value={backupName}
                onChange={(e) => handleSetBackupName(e)}
                placeholder="نام مورد نظر را وارد کنید"
                aria-describedby="defaultFormControlHelp"
              />
              <div id="defaultFormControlHelp" className="form-text">
                فایل پشتیبان شما با این نام ذخیره خواهد شد
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={limited ? "checked" : ""}
                  onChange={() => setLimited((prev) => !prev)}
                  id="limitedBackup"
                />
                <label className="form-check-label" htmlFor="limitedBackup">
                  دسترسی محدود
                </label>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            {/* <button
              type="button"
              className="btn btn-outline-success-app mb-2"
              data-bs-dismiss="modal"
            >
              انصراف
            </button> */}
            <button
              type="button"
              className="btn btn-success-app mb-2"
              onClick={handleSubmit}
            >
              تایید
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BackupModal;
